import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import Seo from "@/components/Seo";
import { usePage } from "@/lib/usePage";

const IMG = "https://images.unsplash.com/photo-1779772809762-c1414769411e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
const IMG2 = "https://images.unsplash.com/photo-1542401886-65d6c61db217?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

const content = {
  fr: {
    kicker: "// 2019 — Nouadhibou",
    lead: "Tout a commencé sur un wagon de minerai, quelque part entre le Sahara et l'Atlantique.",
    p1: "Une nuit de janvier, sans billet, sans confort, sans réseau. Le train le plus long du monde traversait le désert et nous étions dessus — couverts de poussière rouge, les étoiles à portée de main, plus vivants que jamais.",
    p2: "De retour, une évidence : ces expériences n'existaient nulle part au catalogue. Trop brutes, trop rares, trop confidentielles. Alors nous les avons construites nous-mêmes.",
    p3: "HorsSignal est né de cette conviction : le vrai luxe n'est pas le confort, c'est l'accès. L'accès à ce que personne d'autre ne peut vous offrir, à des récits que l'on garde pour la vie.",
    quote: "Nous ne vendons pas la destination. Nous vendons le fait d'y être allé.",
    cta: "Voir les expéditions",
    seo_title: "Notre histoire — HORS SIGNAL",
    seo_description: "Comment HORS SIGNAL est né.",
  },
  en: {
    kicker: "// 2019 — Nouadhibou",
    lead: "It all began on an ore wagon, somewhere between the Sahara and the Atlantic.",
    p1: "A January night, no ticket, no comfort, no signal. The world's longest train crossed the desert and we were on it — covered in red dust, the stars within reach, more alive than ever.",
    p2: "Back home, one thing was obvious: these experiences existed in no catalogue. Too raw, too rare, too confidential. So we built them ourselves.",
    p3: "HorsSignal was born from one conviction: real luxury isn't comfort, it's access. Access to what no one else can offer you, to stories you keep for life.",
    quote: "We don't sell the destination. We sell having been there.",
    cta: "See the expeditions",
    seo_title: "Our story — HORS SIGNAL",
    seo_description: "How HORS SIGNAL was born.",
  },
};

export default function Story() {
  const { t, lang } = useI18n();
  const { content: c } = usePage("about", content[lang]);
  return (
    <div className="pt-32 pb-24">
      <Seo lang={lang} type="article" path="/histoire" title={c.seo_title || content[lang].seo_title} description={c.seo_description || content[lang].seo_description} />
      <div className="mx-auto max-w-4xl px-6 sm:px-12">
        <span className="font-mono-hs text-xs text-[#BC5D2E] tracking-widest uppercase">{c.kicker}</span>
        <h1 className="font-clash font-bold text-5xl sm:text-7xl uppercase tracking-tighter mt-4">{c.title || t("story_title")}</h1>
        <p className="font-clash text-2xl sm:text-3xl uppercase tracking-tight mt-10 leading-tight">{c.lead}</p>
        <img src={IMG} alt="" className="w-full aspect-video object-cover my-12 grayscale" />
        <div className="space-y-8 text-[#D4D4D4] text-lg leading-relaxed max-w-2xl">
          <p>{c.p1}</p>
          <p>{c.p2}</p>
        </div>
        <blockquote className="font-clash text-3xl sm:text-4xl uppercase tracking-tight text-[#BC5D2E] my-16 leading-tight">"{c.quote}"</blockquote>
        <img src={IMG2} alt="" className="w-full aspect-video object-cover my-12 grayscale" />
        <p className="text-[#D4D4D4] text-lg leading-relaxed max-w-2xl">{c.p3}</p>
        <Link to="/expeditions" className="inline-block mt-12 bg-[#BC5D2E] text-white px-8 py-4 uppercase tracking-widest text-sm hover:bg-[#8A281E] transition-colors">{c.cta}</Link>
      </div>
    </div>
  );
}
